export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ZoomContainer.vue?vue&type=template&id=378ea3e4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/zoom/ZoomContainer.vue?vue&type=template&id=378ea3e4&scoped=true&
// module id = 517
// module chunks = 0